import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import { defineNuxtPlugin } from '#imports'
import { deepMerge } from '@antfu/utils'
import defaults from '@base/modules/vuetify/runtime/defaults'
import { icons } from '@base/modules/vuetify/runtime/icons'
import { getTheme } from '@base/modules/vuetify/runtime/theme'
import { cookieRef } from '@base/@layouts/stores/config'
import { themeConfig } from '@base/config'

import 'vuetify/styles'
import '@base/@core/scss/template/libs/vuetify/index.scss'

export default defineNuxtPlugin(nuxtApp => {
  const themes = getTheme()

  const cookieThemeValues = {
    defaultTheme: themeConfig.app.theme,
    themes: {
      light: {
        colors: {
          'primary': cookieRef('lightThemePrimaryColor', themes.light.colors.primary).value,
          'primary-darken-1': cookieRef('lightThemePrimaryDarkenColor', themes.light.colors['primary-darken-1']).value,
        },
      },
      dark: {
        colors: {
          'primary': cookieRef('darkThemePrimaryColor', themes.dark.colors.primary).value,
          'primary-darken-1': cookieRef('darkThemePrimaryDarkenColor', themes.dark.colors['primary-darken-1']).value,
        },
      },
    },
  }

  const vuetifyInstance = createVuetify({
    aliases: {
      IconBtn: VBtn,
    },
    defaults,
    icons,
    theme: deepMerge({ themes }, cookieThemeValues) as any,
  })

  nuxtApp.vueApp.use(vuetifyInstance)
})
